import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useNotification } from "../../contexts/NotificationContext";
import { useUserAPI } from "../../contexts/UserAPIContext";
import { authFetch } from "../../utils/authFetch";

const EditarUsuario = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    const { userAPIData } = useUserAPI();
    const isAdmin = Number(userAPIData?.userRoleId) === 1;
    const isResponsavel = Number(userRoleId) === 3;

    const [name, setName] = useState("");
    const [username, setUsername] = useState("");
    const [userRoleId, setUserRoleId] = useState("");
    const [enabled, setEnabled] = useState(false); // Estado para o campo de status
    const [roles, setRoles] = useState([]); // Lista de perfis de acesso    

    // Buscar perfis de usuário ao carregar a página
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await authFetch('user-role', {
                    method: "GET",
                });

                if (!response.ok) {
                    throw new Error("Erro ao buscar roles");
                }

                const data = await response.json();
                setRoles(data); // Atualiza a lista de perfis de acesso
            } catch (error) {
                console.error("Erro ao buscar roles:", error);
            }
        };

        fetchRoles();
    }, [showNotification]);

    // Carregar os dados do usuário quando a página abrir
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await authFetch(`user/${id}`, {
                    method: "GET",
                });

                if (!response.ok) {
                    throw new Error("Erro ao buscar usuário");
                }

                const data = await response.json();
                setName(data.name);
                setUsername(data.username);
                setUserRoleId(data.userRoleId);
                setEnabled(data.enabled); // Definir o valor inicial do checkbox                
            } catch (error) {
                console.error("Erro ao carregar usuário:", error);
                showNotification("danger", "Erro ao carregar usuário");
            }
        };

        fetchUser();
    }, [id, navigate, showNotification]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const userData = {
            id: Number(id), // ✅ Adicionando ID no corpo da requisição
            username,
            name,
            userRoleId: Number(userRoleId),
            enabled,
        };

        try {
            const response = await authFetch('user', {
                method: "PUT",
                body: JSON.stringify(userData),
            });

            if (!response.ok) {
                throw new Error("Erro ao atualizar usuário");
            }

            showNotification("success", "Usuário atualizado com sucesso!");
            setTimeout(() => navigate("/Usuarios"), 1);
        } catch (error) {
            console.error("Erro:", error);
            showNotification("danger", "Erro ao atualizar usuário");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Editar Usuário</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="usuarios form content">
<form onSubmit={handleSubmit}>
                                <fieldset className="col-md-6" disabled={!isAdmin}>
                                    <label htmlFor="name">Nome</label>
                                    <input type="text" name="name" id="name" className="form-control form-control-sm" value={name} onChange={(e) => setName(e.target.value)} />

                                    <label htmlFor="username">Email</label>
                                    <input type="text" name="username" id="username" className="form-control form-control-sm" value={username} onChange={(e) => setUsername(e.target.value)} readOnly />

                                    <label htmlFor="userRoleId">Perfil de Acesso</label>
                                    <select
                                        name="userRoleId"
                                        id="userRoleId"
                                        className="form-control form-control-sm"
                                        value={userRoleId}
                                        onChange={(e) => setUserRoleId(e.target.value)}
                                        disabled={isResponsavel}
                                    >
                                        {roles.map((role) => (
                                            <option key={role.id} value={role.id}>
                                                {role.name}
                                            </option>
                                        ))}
                                    </select>
                                    {isResponsavel && (
                                        <small className="text-muted">
                                            Perfil gerenciado pelo app — não pode ser alterado.
                                        </small>
                                    )}

                                    <div className="form-check">
                                        <input type="checkbox" className="form-check-input" id="enabled" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />
                                        <label className="form-check-label" htmlFor="enabled">Ativo</label>
                                    </div>

                                    <div className="card-footer" style={{ paddingLeft: "0" }}>
                                        <Link to="/Usuarios" className="btn btn-info btn-sm">
                                            Voltar
                                        </Link>
                                        {isAdmin && (
                                            <button type="submit" className="btn btn-primary btn-sm">
                                                Salvar Alterações
                                            </button>
                                        )}
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditarUsuario